import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter, Route, Routes } from 'react-router';
import { LoginPage, ProtectedRoute } from '@/features/auth';
import { WorkspacesPage } from '@/pages/WorkspacesPage';
import { AppLayout } from '@/layouts/AppLayout';
import { PatientsPage } from '@/pages/PatientsPage';
import { EnrollmentsPage } from '@/pages/EnrollmentsPage';
import { EnrollmentDetailPage } from '@/pages/EnrollmentDetailPage';
import { PatientDetailPage } from '@/pages/PatientDetailPage';
import { WorkspaceSettingsPage } from '@/pages/WorkspaceSettingsPage';
import { NewEnrollmentPage } from '@/pages/NewEnrollmentPage';
// TanStack Query client — configure global defaults here
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            retry: 1,
        },
    },
});
export default function App() {
    return (_jsxs(QueryClientProvider, { client: queryClient, children: [_jsx(BrowserRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: _jsx(LoginPage, {}) }), _jsxs(Route, { element: _jsx(ProtectedRoute, {}), children: [_jsx(Route, { path: "/workspaces", element: _jsx(WorkspacesPage, {}) }), _jsxs(Route, { element: _jsx(AppLayout, {}), children: [_jsx(Route, { path: "/", element: _jsx(PatientsPage, {}) }), _jsx(Route, { path: "/patients/:id", element: _jsx(PatientDetailPage, {}) }), _jsx(Route, { path: "/enrollments", element: _jsx(EnrollmentsPage, {}) }), _jsx(Route, { path: "/enrollments/new", element: _jsx(NewEnrollmentPage, {}) }), _jsx(Route, { path: "/enrollments/:id", element: _jsx(EnrollmentDetailPage, {}) }), _jsx(Route, { path: "/settings", element: _jsx(WorkspaceSettingsPage, {}) })] })] })] }) }), _jsx(ReactQueryDevtools, { initialIsOpen: false })] }));
}
